module.exports = __webpack_public_path__ + "img/learnEnglishMain-tablet.4f2cd377.png";